import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Search1Bold } from '@ha/icons';
import { TextField, TextFieldProps, InputAdornment } from '@ha/dsl';

export const useStyles = makeStyles(() => ({
  input: {
    '&::-webkit-search-cancel-button': {
      '-webkit-appearance': 'none',
    },
  },
}));

const CityTextField: React.FC<TextFieldProps> = ({
  InputProps = {},
  onFocus,
  onBlur,
  onReset,
  ...rest
}) => {
  const classes = useStyles();

  const value = rest.value as string;

  const [focused, setFocused] = React.useState(false);

  const handleFocus = React.useCallback(
    (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setFocused(true);

      if (onFocus) {
        onFocus(e);
      }
    },
    [onFocus],
  );

  const handleBlur = React.useCallback(
    (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setFocused(false);

      if (onBlur) {
        onBlur(e);
      }
    },
    [onBlur],
  );

  // hide country when input is not selected
  const displayValue = focused ? value : value.split(',')[0];

  return (
    <TextField
      type="search"
      onFocus={handleFocus}
      onBlur={handleBlur}
      InputProps={{
        classes: {
          input: classes.input,
        },
        startAdornment: (
          <InputAdornment position="start">
            <Search1Bold color="disabled" fontSize="inherit" />
          </InputAdornment>
        ),
        ...InputProps,
        value: displayValue,
      }}
      {...rest}
    />
  );
};

export default CityTextField;
